export default __webpack_public_path__ + "static/media/Flaticon.a010b35e.woff2";